import * as yup from 'yup';

export const snoozeTaskValidationSchema = yup.object().shape({
	days: yup.number().positive('Number of days must be positive number').required('This field is required'),
});
